module.exports = __webpack_public_path__ + "img/Home.d6686cea.svg";